import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/terms/page.tsx");
